import { Avatar, CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react';
import DetailsCard from './components/DetailsCard';
// import useResponsive from '../../../../Hooks/useResponsive';
import {
  academicDetails,
  contactDetails,
  environmentDetails,
  parentDetails,
  personalityDetails,
  sibilingsDetails,
  studentDetails,
} from './labelData';
import { useSelector } from 'react-redux';
// import { getAdmRegStudentDetails } from '../../../../redux/features/CRDslice';
// import { useSelector } from 'react-redux';

export default function StudentProfileLanding({ admNo }) {
  // const isLarge = useResponsive('up', 'lg');
  const { admRegStudentProfile, loading } = useSelector((state) => state.crd);

  // useEffect(() => {
  //   dispatch(getAdmRegStudentDetails(admNo));
  // }, []);

  const mainColor = '#f4f6f8';
  return (
    <Box>
      {loading ? (
        <Box display={'flex'} width={'100%'} justifyContent={'center'}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              height: '100px',
              background:
                // "center/cover no-repeat url(/static/illustrations/cabin.jpg)",// cover photo
                'linear-gradient(90deg,rgba(42, 123, 155, 1) 8%, rgba(211, 222, 224, 1) 38%, rgba(49, 136, 158, 1) 71%, rgba(42, 123, 155, 1) 100%)',
              width: '100%',
              borderRadius: { md: '50px 0 0 0', xs: '50px 50px 0 0' },
            }}
          />
          <Box bgcolor={mainColor} position={'relative'} minHeight={{ md: '80px', xs: '120px' }}>
            <Box
              sx={{
                position: 'absolute',
                top: -28,
                left: { md: 20, xs: '50%' },
                transform: { md: 'none', xs: 'translateX(-50%)' },
                display: 'flex',
                gap: { md: 3, xs: 1 },
                flexDirection: { md: 'row', xs: 'column' },
              }}
            >
              <Avatar
                sx={{
                  height: 90,
                  width: 90,
                  border: `2px solid ${mainColor}`,
                }}
              />
              <Typography
                variant="h5"
                sx={{
                  mt: { md: 4, xs: 0 },
                  textAlign: 'center',
                }}
              >
                {admRegStudentProfile?.studentName}
              </Typography>
            </Box>
          </Box>
          <Box bgcolor={mainColor} px={3}>
            <Box bgcolor={'#e0e4e9'} height={3} width={'100%'} />
          </Box>
          <Box bgcolor={mainColor} p={3}>
            <Box display={'flex'} gap={2} flexDirection={{ xs: 'column', md: 'row' }}>
              <DetailsCard title={'Student Details'} label={studentDetails} data={admRegStudentProfile} />
              <Box flexGrow={1} display={'flex'} flexDirection={'column'} gap={2}>
                <DetailsCard
                  title={'Parent / Guardian Info'}
                  sx={{ flexGrow: 1 }}
                  fullWidth
                  label={parentDetails}
                  data={admRegStudentProfile}
                />
                {Boolean(admRegStudentProfile?.hasSiblings) && (
                  <DetailsCard
                    title={'Sibilings Info'}
                    sx={{ flexGrow: 1 }}
                    fullWidth
                    label={sibilingsDetails}
                    data={admRegStudentProfile?.siblings}
                  />
                )}
                {/* <Box
                display={'flex'}
                justifyContent={'space-between'}
                gap={2}
                flexDirection={{ xs: 'column', lg: 'row' }}
              > */}
                <DetailsCard
                  title={'Family & Environment'}
                  label={environmentDetails}
                  fullWidth
                  data={admRegStudentProfile}
                />
                <DetailsCard title={'Contact Details'} label={contactDetails} fullWidth data={admRegStudentProfile} />
                {/* </Box> */}
                {/* <DetailsCard
                title={"Payment Details"}
                label={paymentDetails}
                fullWidth
              /> */}
              </Box>
            </Box>
            <DetailsCard
              title="Academic Details"
              label={academicDetails}
              sx={{ mt: 2 }}
              fullWidth
              data={admRegStudentProfile}
            />

            <DetailsCard
              title="Personality & Preferences"
              label={personalityDetails}
              sx={{ mt: 2 }}
              fullWidth
              data={admRegStudentProfile}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
